// extracted by mini-css-extract-plugin
export default {"fileUploader":"fileUploader---sCj2K","fileUploaderTitle":"fileUploaderTitle---xrNkz"};